"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var MenuItems_1 = __importDefault(require("./MenuItems"));
var DropZone_1 = __importDefault(require("./DropZone"));
var BlDropzoneThumb_1 = __importDefault(require("../BlDropzone/BlDropzoneThumb"));
var mediaHelper_1 = require("../../../helpers/mediaHelper");
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var deviceHelper_1 = require("../../../helpers/deviceHelper");
var react_dnd_touch_backend_1 = require("react-dnd-touch-backend");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var Sortable_1 = __importDefault(require("../BlDropzone/Sortable"));
var react_dnd_1 = require("react-dnd");
var useMediaPreview_1 = require("../../../hooks/useMediaPreview");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DeveloperParentEntityFileUpload = function (_a) {
    var values = _a.values, onChange = _a.onChange, onRemoved = _a.onRemoved, onReordering = _a.onReordering, onReordered = _a.onReordered, errors = _a.errors;
    var _b = react_1.useState(GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_PICTURES), activeItem = _b[0], setActiveItem = _b[1];
    var openPreview = useMediaPreview_1.useMediaPreview();
    react_1.useEffect(function () {
        var _a;
        if ((_a = errors.about_building) === null || _a === void 0 ? void 0 : _a.media) {
            setActiveItem(GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_PICTURES);
        }
    }, [errors]);
    var composePreviewMedia = function () {
        return values.map(function (file) { return (__assign(__assign({}, file), { url: file.path })); });
    };
    var thumbs = values.map(function (file, index) {
        return (file.building_media_type === activeItem && (react_1.default.createElement(BlDropzoneThumb_1.default, { key: file.id, path: mediaHelper_1.resolveThumb(file), onClick: function () {
                openPreview(composePreviewMedia(), index);
            }, onRemove: function () {
                onRemoved(file.id);
            } })));
    });
    var handleDropZoneChange = function (files) {
        onChange(files, activeItem);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MenuItems_1.default, { setActiveItem: setActiveItem, activeItem: activeItem }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", null,
                react_1.default.createElement(DropZone_1.default, { handleDropZoneChange: handleDropZoneChange })),
            activeItem !== GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_PICTURES ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.uploaded_files }, thumbs)) : (react_1.default.createElement(react_dnd_1.DndProvider, { backend: deviceHelper_1.isMobile() ? react_dnd_touch_backend_1.TouchBackend : react_dnd_html5_backend_1.HTML5Backend },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.uploaded_files }, thumbs.map(function (t, i) { return (react_1.default.createElement(Sortable_1.default, { key: i, index: i, onMove: onReordering, onDrop: onReordered }, t)); })))))));
};
exports.default = DeveloperParentEntityFileUpload;
